/**
 * Mïa · Body Scrub de oferta com o código de uma criadora (UGC)
 * - Quando o carrinho tem um código UGC (terminado em "-MIA") e a compra é >= mínimo,
 *   adiciona 1 Body Scrub de oferta (linha marcada com _oferta_mia = ugc).
 * - Retira a oferta quando o código sai do carrinho ou a compra desce abaixo do mínimo.
 * - O preço a 0 € é calculado pelo desconto "compre X, receba Y" da Shopify associado aos códigos.
 * Funciona com o link da criadora (/discount/CODIGO) e com o campo de código do carrinho.
 */
(function () {
  'use strict';

  var el = document.getElementById('mia-oferta-ugc-dados');
  if (!el) return;
  var CFG;
  try { CFG = JSON.parse(el.textContent); } catch (e) { return; }
  if (!CFG || !CFG.ativo || !CFG.oferta) return;

  var PROP = '_oferta_mia';
  var MARCA = 'ugc';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SUFIXO = String(CFG.sufixo || '-MIA').toUpperCase();
  var EXCLUIR = (CFG.excluir || []).map(function (c) { return String(c).toUpperCase(); });
  var MINIMO = parseInt(CFG.minimo, 10) || 0;
  var ocupado = false;
  var varianteOferta = null;
  var ultimo = null;

  function dinheiro(cents) {
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function eCodigoUgc(codigo) {
    var c = String(codigo || '').trim().toUpperCase();
    if (!c || EXCLUIR.indexOf(c) !== -1) return false;
    return c.length > SUFIXO.length && c.slice(-SUFIXO.length) === SUFIXO;
  }

  function codigoNoCarrinho(carrinho) {
    var lista = carrinho.discount_codes || [];
    for (var i = 0; i < lista.length; i++) if (eCodigoUgc(lista[i].code)) return lista[i].code;
    return null;
  }

  function linhasOferta(carrinho) {
    return (carrinho.items || []).filter(function (it) {
      return it.properties && it.properties[PROP] === MARCA;
    });
  }

  /* Valor das compras: exclui todas as linhas de oferta (UGC e campanhas). */
  function valorCompra(carrinho) {
    var total = 0;
    (carrinho.items || []).forEach(function (it) {
      if (it.properties && it.properties[PROP]) return;
      total += it.final_line_price;
    });
    return total;
  }

  function lerCarrinho() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { ultimo = c; return c; });
  }

  function obterVariante() {
    if (varianteOferta) return Promise.resolve(varianteOferta);
    return fetch(ROOT + 'products/' + CFG.oferta + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { varianteOferta = p.variants[i].id; break; }
        }
        return varianteOferta;
      })
      .catch(function () { return null; });
  }

  function atualizarCarrinho(linhas) {
    var a = window.Shopify && window.Shopify.actions;
    if (a && a.updateCart) return a.updateCart({ lines: linhas }).catch(function () {});
    var adicionar = linhas.filter(function (l) { return !l.id; });
    var alterar = linhas.filter(function (l) { return l.id; });
    var p = Promise.resolve();
    alterar.forEach(function (l) {
      p = p.then(function () {
        return fetch(ROOT + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: l.id, quantity: l.quantity })
        });
      });
    });
    if (adicionar.length) {
      p = p.then(function () {
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: adicionar.map(function (l) {
            var props = {}; props[PROP] = MARCA;
            return { id: l.merchandiseId, quantity: 1, properties: props };
          }) })
        });
      });
    }
    return p.then(function () { location.reload(); });
  }

  /* Acerta a oferta UGC no carrinho. Devolve true se alterou o carrinho. */
  function corrigir(carrinho) {
    var codigo = codigoNoCarrinho(carrinho);
    var ofertas = linhasOferta(carrinho);
    var cumpre = !!codigo && valorCompra(carrinho) >= MINIMO;
    var linhas = [];

    if (!cumpre) {
      ofertas.forEach(function (it) { linhas.push({ id: it.key, quantity: 0 }); });
      if (!linhas.length) return Promise.resolve(false);
      return atualizarCarrinho(linhas).then(function () { return true; });
    }

    if (ofertas.length) {
      ofertas.slice(1).forEach(function (it) { linhas.push({ id: it.key, quantity: 0 }); });
      if (ofertas[0].quantity > 1) linhas.push({ id: ofertas[0].key, quantity: 1 });
      if (!linhas.length) return Promise.resolve(false);
      return atualizarCarrinho(linhas).then(function () { return true; });
    }

    return obterVariante().then(function (vid) {
      if (!vid) return false;
      return atualizarCarrinho([{ merchandiseId: String(vid), quantity: 1, attributes: [{ key: PROP, value: MARCA }] }])
        .then(function () { return true; });
    });
  }

  /* Mensagem na gaveta do carrinho. */
  function renderGaveta(carrinho) {
    var alvo = document.querySelector('#cart-drawer .cart-drawer__items');
    if (!alvo) return;
    var caixa = alvo.querySelector('.mia-carrinho-ugc');
    var codigo = codigoNoCarrinho(carrinho);
    if (!codigo) { if (caixa) caixa.remove(); return; }

    var valor = valorCompra(carrinho);
    var html;
    if (valor >= MINIMO) {
      html = '<p class="mia-carrinho__titulo">Body Scrub de oferta</p>' +
        '<p class="mia-carrinho__estado"><strong>Oferta desbloqueada.</strong> Com o código ' + codigo.toUpperCase() +
        ', o seu Body Scrub de oferta já está no carrinho.</p>';
    } else {
      html = '<p class="mia-carrinho__titulo">Body Scrub de oferta</p>' +
        '<p class="mia-carrinho__estado">Com o código ' + codigo.toUpperCase() + ', receba um Body Scrub de oferta em compras a partir de ' +
        dinheiro(MINIMO) + '. Faltam ' + dinheiro(MINIMO - valor) + '.</p>';
    }
    if (!caixa) {
      caixa = document.createElement('div');
      caixa.className = 'mia-carrinho mia-carrinho-ugc';
      alvo.insertBefore(caixa, alvo.firstChild);
    }
    caixa.innerHTML = '<div class="mia-carrinho__item' + (valor >= MINIMO ? ' is-desbloqueada' : '') + '">' + html + '</div>';
  }

  function atualizar() {
    if (ocupado) return Promise.resolve();
    ocupado = true;
    return lerCarrinho()
      .then(function (c) { return corrigir(c).then(function (mudou) { return mudou ? lerCarrinho() : c; }); })
      .then(function (c) { renderGaveta(c); })
      .catch(function () {})
      .then(function () { ocupado = false; });
  }

  /* Campo de código do carrinho: com um código UGC, adicionar primeiro a oferta
     (senão a Shopify considera o código "não aplicável") e só depois aplicar o código. */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.classList || !form.classList.contains('cart-discount__form')) return;
    if (form.dataset.miaUgcOk === '1') { delete form.dataset.miaUgcOk; return; }
    var input = form.querySelector('input[name="discount"]');
    var codigo = input && input.value;
    if (!eCodigoUgc(codigo)) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();

    lerCarrinho().then(function (c) {
      var valor = valorCompra(c);
      if (valor < MINIMO) {
        var comp = form.closest('cart-discount-component');
        var erro = comp && comp.querySelector('.cart-discount__error');
        var texto = comp && comp.querySelector('[ref="cartDiscountErrorDiscountCode"]');
        if (erro && texto) {
          texto.textContent = 'O código ' + String(codigo).toUpperCase() + ' é válido em compras a partir de ' +
            dinheiro(MINIMO) + '. Faltam ' + dinheiro(MINIMO - valor) + '.';
          erro.classList.remove('hidden');
          texto.classList.remove('hidden');
        }
        return;
      }
      var p = linhasOferta(c).length ? Promise.resolve() : obterVariante().then(function (vid) {
        if (!vid) return;
        var props = {}; props[PROP] = MARCA;
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
        });
      });
      p.then(function () {
        form.dataset.miaUgcOk = '1';
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });
  }, true);

  /* ---------- Sincronização ---------- */
  var t1, t2;
  function agendar() {
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(atualizar, 500);
    t2 = setTimeout(atualizar, 1800);
  }
  ['shopify:cart:lines-update', 'shopify:cart:discount-update', 'cart:update', 'cart:updated'].forEach(function (nome) {
    document.addEventListener(nome, agendar, true);
  });

  function observarGaveta() {
    var gaveta = document.getElementById('cart-drawer');
    if (!gaveta || gaveta.dataset.miaUgcObs) return;
    gaveta.dataset.miaUgcObs = '1';
    new MutationObserver(function () {
      var itens = gaveta.querySelector('.cart-drawer__items');
      if (itens && !itens.querySelector('.mia-carrinho-ugc') && ultimo && codigoNoCarrinho(ultimo)) renderGaveta(ultimo);
    }).observe(gaveta, { childList: true, subtree: true });
  }

  function iniciar() { observarGaveta(); atualizar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  window.addEventListener('pageshow', function (e) { if (e.persisted) atualizar(); });
})();
